import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles({
  input: {
    padding: 'clamp(2.3px, 0.29vw, 3.8px) clamp(2px, 0.15vw, 8px) !important',
    fontSize: 'clamp(0.69rem, 1.04vw, 0.90rem)',
    color: '#002D55',
    borderRadius: 14,
    fontWeight: 500,
    '&::placeholder': {
      color: '#002D55',
      fontWeight: 'normal',
      fontSize: 'clamp(0.69rem, 0.90rem)',
      letterSpacing: '0.1px',
      opacity: 1,
      transition: 'opacity 0.2s',
    },
    '&:focus::placeholder': {
      opacity: 0.3,
    },
    '& .MuiSelect-select': {
      padding: 'clamp(0px, 0.29vw, 0px) clamp(18px, 0.15vw, 24px) !important',
      minHeight: 'unset !important',
      lineHeight: 'normal',
      background: 'transparent',
    },
  },
  responsiveOption: {
    fontSize: 'clamp(0.69rem, 0.69vw, 0.93rem)',
    color: '#002D55',
  },
  paper: {
    borderRadius: 14,
  },
  orangeFocused: {
    // Remove Autocomplete's own 9px padding from the root so only input padding applies
    '& .MuiOutlinedInput-root': {
      padding: '1px !important',
      fontSize: 'clamp(0.69rem, 1.04vw, 0.90rem)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ccc',
      borderRadius: 14,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#FF7F27',
      borderWidth: 1,
    },
  },
});

const ExerciseSearchbar = ({exercises, searchInput, setSearchInput, fullWidth = false}) => {
  const classes = useStyles();

  return (
    <div style={{ width: fullWidth ? '100%' : '50%', minWidth: 0, maxWidth: fullWidth ? '100%' : 800, backgroundColor: "transparent", margin: '0 auto', paddingLeft: fullWidth ? 0 : "2.5%" }}>
      <Autocomplete
        freeSolo
        options={exercises}
        disableClearable={false}
        inputValue={searchInput}
        classes={{ paper: classes.paper }}
        onChange={(event, option) => {
          // When user clicks a suggestion, set input to that title
          if (option && typeof option === 'object') setSearchInput(option.title);
        }}
        onInputChange={(event, newValue, reason) => {
          if (reason === 'reset') return; // don't wipe input when focus leaves or option clicked
          if (reason === 'clear') { setSearchInput(''); return; }
          setSearchInput(newValue);
        }}
        getOptionLabel={(option) => `${option.title}`}
        renderOption={(option) => (
          <div className={classes.responsiveOption}>{option.title}</div>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            className={classes.orangeFocused}
            placeholder="Search exercise"
            margin="none"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              type: 'text',
              classes: { input: classes.input },
              style: { backgroundColor: '#FFF', borderRadius: 14, overflow: 'hidden' },
              startAdornment: (
                <InputAdornment position="start" style={{ marginLeft: 6 }}>
                  <SearchIcon style={{ fontSize: 16, color: '#002D55', opacity: 0.5 }} />
                </InputAdornment>
              ),
            }}
            onKeyDown={event => {
              if (event.key === 'Escape') setSearchInput('');
            }}
          />
        )}
      />
    </div>
  );
}

export default ExerciseSearchbar